import { render, staticRenderFns } from "./CompanyCount.vue?vue&type=template&id=6867299a&scoped=true&"
import script from "./CompanyCount.vue?vue&type=script&lang=js&"
export * from "./CompanyCount.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCount.vue?vue&type=style&index=0&id=6867299a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867299a",
  null
  
)

export default component.exports